import { AdInterstitial, AdNative, AdOpen, AdRewarded, Adbanner } from '@tencent/odc-iconpack';
import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import './index.scss';

type Props = {
  onTabChange?: (tab: AdFormatsEnum) => void;
};
export enum AdFormatsEnum {
  Rewarded = 'Rewarded',
  Interstitial = 'Interstitial',
  Native = 'Native',
  Banner = 'Banner',
  AppOpen = 'App Open',
}
export const adFormatsList = [
  {
    key: AdFormatsEnum.Rewarded,
    icon: <AdRewarded />,
    title: AdFormatsEnum.Rewarded,
  },
  {
    key: AdFormatsEnum.Interstitial,
    icon: <AdInterstitial />,
    title: AdFormatsEnum.Interstitial,
  },
  {
    key: AdFormatsEnum.Native,
    icon: <AdNative />,
    title: AdFormatsEnum.Native,
  },
  {
    key: AdFormatsEnum.Banner,
    icon: <Adbanner />,
    title: AdFormatsEnum.Banner,
  },
  {
    key: AdFormatsEnum.AppOpen,
    icon: <AdOpen />,
    title: AdFormatsEnum.AppOpen,
  },
];
const AdFormatsTabs = (props: Props) => {
  const { onTabChange } = props;
  const [activeTab, setActiveTab] = useState<AdFormatsEnum>(AdFormatsEnum.Rewarded);
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScroll = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    const hasOverflow = el.scrollWidth > el.clientWidth;
    const isAtEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2;
    setCanScrollRight(hasOverflow && !isAtEnd);
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    checkScroll();
    el.addEventListener('scroll', checkScroll, { passive: true });
    window.addEventListener('resize', checkScroll);
    return () => {
      el.removeEventListener('scroll', checkScroll);
      window.removeEventListener('resize', checkScroll);
    };
  }, [checkScroll]);

  return (
    <div className={classNames('odc-ad-formats-tabs-wrapper', { 'can-scroll-right': canScrollRight })}>
      <div className="odc-ad-formats-tabs" ref={scrollRef}>
        {adFormatsList.map((item) => (
          <div className={classNames('ad-format-tab', {
            'active': item.key === activeTab,
          })}
            key={item.key}
            onClick={() => {
              setActiveTab(item.key);
              onTabChange?.(item.key);
            }}
          >
            <div className="ad-format-icon">{item.icon}</div>
            <div className="ad-format-title">{item.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdFormatsTabs;
